import { useState } from 'react';
import { SocialService } from '../../services/socialService';
import styles from './CollectorsToFollow.module.css';
import { FoundingCollectorIcon } from '../FoundingCollectorBadge/FoundingCollectorBadge';

const RARITY_THRESHOLDS = [
    { label: 'LEGENDARY', min: 0,   legendaryMin: 3, color: '#D4AF37', bg: 'rgba(212,175,55,0.12)' },
    { label: 'GOLD',      min: 100, legendaryMin: 0, color: '#C8A84B', bg: 'rgba(200,168,75,0.12)'  },
    { label: 'SILVER',    min: 25,  legendaryMin: 0, color: '#A8B0B8', bg: 'rgba(168,176,184,0.12)' },
    { label: 'BRONZE',    min: 10,  legendaryMin: 0, color: '#8B5E3C', bg: 'rgba(139,94,60,0.12)'   },
];

function getRarity(coinCount, legendaryCount) {
    if (legendaryCount >= 3) return RARITY_THRESHOLDS[0];
    if (coinCount >= 100)    return RARITY_THRESHOLDS[1];
    if (coinCount >= 25)     return RARITY_THRESHOLDS[2];
    if (coinCount >= 10)     return RARITY_THRESHOLDS[3];
    return null;
}

function FollowButton({ userId }) {
    const [state, setState] = useState('idle'); // 'idle' | 'loading' | 'done'

    async function handleClick() {
        if (state !== 'idle') return;
        setState('loading');
        try {
            await SocialService.follow(userId);
            setState('done');
        } catch {
            setState('idle');
        }
    }

    if (state === 'done') {
        return <span className={styles.followingBadge}>Following</span>;
    }
    return (
        <button className={styles.followBtn} onClick={handleClick} disabled={state === 'loading'}>
            {state === 'loading' ? '…' : 'Follow'}
        </button>
    );
}

export default function CollectorsToFollow({ collectors = [], currentUserId, onViewProfile }) {
    if (!collectors.length) return null;

    return (
        <section className={styles.section}>
            <h2 className={styles.title}>👥 Collectors to Follow</h2>
            <div className={styles.track}>
                {collectors.map((u, i) => {
                    const coins     = u.coin_count ?? u.coinCount ?? 0;
                    const legendary = u.legendary_count ?? u.legendaryCount ?? 0;
                    const rarity    = getRarity(coins, legendary);
                    const initial   = (u.display_name || u.username || '?')[0].toUpperCase();

                    return (
                        <article key={u.id ?? i} className={styles.card}>
                            <button
                                className={styles.avatarBtn}
                                onClick={() => onViewProfile?.(u.username)}
                                style={{ '--ring': rarity?.color ?? 'var(--border-subtle)' }}
                            >
                                {u.avatar_url
                                    ? <img src={u.avatar_url} alt="" className={styles.avatar} />
                                    : <div className={styles.avatarFallback} style={{ color: rarity?.color ?? 'inherit' }}>{initial}</div>
                                }
                            </button>

                            <p className={styles.username}>
                                @{u.username}
                                <FoundingCollectorIcon isFoundingCollector={u.isFoundingCollector ?? u.is_founding_collector} />
                            </p>
                            <p className={styles.coinCount}>🪙 {coins}</p>

                            {rarity && (
                                <span
                                    className={styles.rarityBadge}
                                    style={{ color: rarity.color, background: rarity.bg }}
                                >
                                    {rarity.label}
                                </span>
                            )}

                            <FollowButton userId={u.id} />
                        </article>
                    );
                })}
            </div>
        </section>
    );
}